export const engagementAppGroupIdWhatsappMmLiteApiStatusMessagingServiceId =
  "/engagement/:app_group_id/whatsapp/mm_lite_api_status/:messaging_service_id";
